import { VendorEntity } from '@resident-select/domain/vendor';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';
import { VendorCompanyEntity } from '@resident-select/domain/vendor-company';

export const GottenVendorCompaniesEvent = createAction(
  'GottenVendorCompaniesEvent',
  props<{ entities: VendorCompanyEntity[] }>(),
);
